<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!--    <template #header>-->
    <!--      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>-->
    <!--    </template>-->

    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Báo cáo chi tiết theo dõi chỉ đạo
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Thời gian chỉ đạo" class="formItem">
              <el-date-picker
                v-model="commandsDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                clearable
                @change="commandsDateRangeChanged"
                size="medium"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="Hạn hoàn thành" class="formItem">
              <el-date-picker
                v-model="deadlineRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="deadlineRangeChanged"
                size="medium"
                clearable
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Lĩnh vực" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.sectors"
                placeholder="Lĩnh vực"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in sectors"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Lãnh đạo chỉ đạo" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.directiveIds"
                placeholder="Lãnh đạo phụ trách"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in listDirectives"
                  :key="item.id"
                  :label="`${item.fullName} - ${item.positionName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Lãnh đạo phụ trách" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.performIds"
                placeholder="Lãnh đạo phụ trách"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in listDirectives"
                  :key="item.id"
                  :label="`${item.fullName} - ${item.positionName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Trạng thái" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.commandStatusList"
                placeholder="Trạng thái"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in commandStatusSelectOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Đánh giá tiến độ" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.progressStatus"
                placeholder="Trạng thái"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in progressStatusSelectOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="exportReportExcel">
          <i class="fa fa-file-excel" aria-hidden="true"></i>
          &nbsp;Xuất Excel
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="resetForm"
          >Khởi tạo</el-button
        >
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import dateFormatter from "../../../filters/dateFormatter";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcFlowService from "../../../services/hcFlowService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "hc-command-report-dialog",
  components: { CustomDialog },
  filters: { dateFormatter },
  props: ["isOpen", "inputForm", "inputPageable"],

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  data() {
    return {
      form: {
        fromDeadline: null,
        toDeadline: null,
        fromCommandsDate: null,
        toCommandsDate: null,
        directiveIds: null,
        performIds: null,
        sectors: null,
        commandStatusList: null,
        progressStatus: null
      },
      departments: null,
      deadlineRange: null,
      commandsDateRange: null,
      dateQuickFilterOption: null,
      listDirectives: null,
      sectors: null,
      commandStatusSelectOptions: null,
      progressStatusSelectOptions: null,
      hcFlow: null,
      pageable: { sort: null, order: null }
    };
  },

  async created() {
    this.initSelectOptions();
    this.initDateQuickFilterOption();
    this.initQuery();
    await this.loadHcFlow();
    await this.loadDirectiveActors();
  },

  methods: {
    resetForm() {
      this.initQuery();
    },

    loadHcFlow() {
      return hcFlowService
        .getHcFlowAlternativeForHcCommands()
        .then(response => (this.hcFlow = response.data));
    },

    loadDirectiveActors() {
      return userDeptRoleViewService
        .findAllForHcCommands(this.hcFlow.deptId)
        .then(response => (this.listDirectives = response.data));
    },

    initSelectOptions() {
      hanhChinhUtils
        .buildHcCommandSectorOptions()
        .then(sectors => (this.sectors = sectors));
      this.commandStatusSelectOptions = hanhChinhUtils.buildHcCommandStatusOptions();
      this.progressStatusSelectOptions = this.buildProgressStatusOptions();
    },

    buildProgressStatusOptions() {
      return [
        {
          id: constants.HC_CASE_COMMANDS.PROGRESS_STATUS.DUNG_TIEN_DO,
          name: "Đúng tiến độ"
        },
        { id: constants.HC_CASE_COMMANDS.PROGRESS_STATUS.CHAM, name: "Chậm" }
      ];
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    commandsDateRangeChanged() {
      utils.timeRangeChanged(this.commandsDateRange, (from, to) => {
        this.form.fromCommandsDate = from;
        this.form.toCommandsDate = to;
      });
    },

    deadlineRangeChanged() {
      utils.timeRangeChanged(this.deadlineRange, (from, to) => {
        this.form.fromDeadline = from;
        this.form.toDeadline = to;
      });
    },

    initQuery() {
      this.form = utils.merge(this.form, this.inputForm);
      this.pageable = utils.merge(this.pageable, this.inputPageable);
      this.initDeadlineRange();
      this.initCommandsDateRange();
    },

    initDeadlineRange() {
      this.deadlineRange = utils.initTimeRange(
        this.form.fromDeadline,
        this.form.toDeadline
      );
    },

    initCommandsDateRange() {
      this.commandsDateRange = utils.initTimeRange(
        this.form.fromCommandsDate,
        this.form.toCommandsDate
      );
    },

    validate() {
      return new Promise(resolve => {
        resolve();
      });
    },

    exportReportExcel() {
      let query = utils.merge(this.form, {
        userDeptRoleId: this.userDeptRoleId,
        sort: [this.pageable.sort, this.pageable.order].join(",")
      });
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.REPORT.HC_COMMANDS.BAO_CAO_CHI_TIET_URL;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
        "_blank "
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/report/hcCommands/hc-command-report-dialog.vue